import React from 'react'
import { ReactQueryConfigProvider } from 'react-query'
import { AuthProvider } from './auth-context'

const queryConfig = {
  queries: {
    useErrorBoundary: true,
    refetchOnWindowFocus: false,
    retry(failureCount, error) {
      const httpFatalErrors = [400, 403, 404, 405, 500, 502, 503, 522]
      if (httpFatalErrors.includes(error.status)) return false
      else return failureCount < 3
    },
  },
}

function AppProviders({ children }) {
  return (
    <ReactQueryConfigProvider config={queryConfig}>
      <AuthProvider>{children}</AuthProvider>
    </ReactQueryConfigProvider>
  )
}

export { AppProviders }
